import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { AlertModal } from "./AlertModal";
export const DeleteButton = ({
  onConfirm
}) => {
  const [showConfirmModal, setConfirmModal] = useState(false);
  return <>
      <button className="foundry--button button--text" onClick={() => setConfirmModal(true)}>
        <FontAwesomeIcon className="delete-image-btn--icon" icon={faTrashAlt} role="img" title="Delete Image" />
      </button>
      {showConfirmModal && <AlertModal modalTitle="Are You Sure?" type="danger" cancelAction={() => setConfirmModal(false)} confirmAction={onConfirm} cancelBtnText="Cancel" confirmBtnText="Delete">
          Are you sure you want to delete this data? This action cannot be
          undone.
        </AlertModal>}
    </>;
};